export const environment = {
  VERSION        : 2.2,
  API_ENDPOINT   : 'https://mapapp.apps.airliquide.com/api',
  API_KEY        : 'PAkfg6471E58enb5GS899TeVucz6biu9',
  RESET_PASS_URL : 'https://mapapp.apps.airliquide.com/portal/#/createpassword/{0}',
  GOOGLE_AUTH_ID : '203031426868-ohgf659aqr5i202t22d543rtpntu52mi.apps.googleusercontent.com',
}


// WEBPACK FOOTER //
// ./src/environments/environment.ts